"use client";
import React from "react";

const ButtonActionDefault: React.FC = () => {
  return (
    <button
      onClick={() => window.open("https://clickcannabis.com")}
      className="h-10 px-6 flex items-center justify-center border border-brand-dark rounded-xl text-brand-dark"
    >
      Visite nosso site
    </button>
  );
};

export default ButtonActionDefault;
